import BorderedBox from "@callveriq/components/custom_components/BorderedBox";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    alpha,
    Typography,
} from "@mui/material";
import CustomSkeletonLoader from "@callveriq/components/custom_components/Skeleton";
import { useLazyGetResoursesQuery } from "@callveriq/redux/services/lms/lmsKnowledgeBase.service";
import { Label } from "@callveriq/components/custom_components/Typography/Label";
import { ArrowDropDown } from "@mui/icons-material";

const ListItem = ({
    item,
}: {
    item: { name: string; type: "file" | "folder"; id: number };
}) => {
    const [getDocuments, { data: documents, isFetching: isLmsDocsLoading }] =
        useLazyGetResoursesQuery();

    const onFolderClick = () => {
        getDocuments(
            {
                file_ext_type: [".csv", ".docx", ".md", ".pdf", ".json"],
                allow_pagination: false,
                category_id: item.id,
            },
            true
        );
    };
    if (item.type === "file") {
        return (
            <BorderedBox
                p={1.5}
                sx={{
                    border: "1px solid rgba(153, 153, 153, 0.20)",
                    borderRadius: "4px",
                    boxShadow: "none",
                }}
            >
                <div className="flex items-center gap-2.5">
                    <InsertDriveFileOutlinedIcon
                        sx={{ height: 16, width: 16 }}
                    />
                    <Typography variant="textSm">{item.name}</Typography>
                </div>
            </BorderedBox>
        );
    }
    if (item.type === "folder") {
        return (
            <Accordion
                sx={{
                    border: 1,
                    borderColor: (theme) =>
                        alpha(theme.palette.textColors[999], 0.2),
                    borderRadius: "4px",
                    boxShadow: "none",
                    m: "0px !important",
                }}
            >
                <AccordionSummary
                    sx={{
                        minHeight: "0px !important",
                        "& .Mui-expanded": {
                            py: 1.5,
                            m: "0px !important",
                        },
                    }}
                    component="div"
                    onClick={onFolderClick}
                    expandIcon={
                        <ArrowDropDown
                            sx={{
                                color: "textColors.333",
                            }}
                        />
                    }
                >
                    <div className="flex items-center gap-2.5">
                        <FolderOutlinedIcon sx={{ height: 16, width: 16 }} />
                        <Typography variant="textSm">{item.name}</Typography>
                    </div>
                </AccordionSummary>
                <AccordionDetails
                    sx={{
                        pt: 0.5,
                    }}
                >
                    {isLmsDocsLoading ? (
                        <div className="flex items-center justify-center h-full">
                            <CustomSkeletonLoader rows={2} />
                        </div>
                    ) : (
                        <div className="flex flex-col gap-3">
                            {documents?.results.map((doc) => (
                                <div
                                    className="flex items-center gap-2.5 max-w-[200px]"
                                    key={doc.id}
                                >
                                    <InsertDriveFileOutlinedIcon
                                        sx={{
                                            height: 16,
                                            width: 16,
                                            color: (theme) =>
                                                theme.palette.textColors[666],
                                        }}
                                    />
                                    <Label
                                        variant="textSm"
                                        colorType="666"
                                        isEllipses
                                        hasTooltip
                                    >
                                        {doc.filename}
                                    </Label>
                                </div>
                            ))}
                        </div>
                    )}
                </AccordionDetails>
            </Accordion>
        );
    }
};

export default ListItem;
